<template>
  <div
    class="w-full h-[60px] md:h-[80px] lg:h-[90px] bg-gradient-to-b from-[#0F2377] via-[#0F2377] to-[#304e94] rounded-b-2xl md:rounded-b-3xl relative">
    <div class="absolute top-0 right-0 bg-[#0F2377] h-full w-full -z-[1]"></div>
    <!-- Header -->
    <div class="relative">
      <div class="max-w-7xl w-full mx-auto">
        <!-- Mobile Header -->
        <MobileMenu :shouldShowIcon="shouldShowIcon" :toggleSearch="toggleSearch" :showSearch="showSearch"
          :fetchResults="fetchResults" :goToSearchPage="goToSearchPage" :showSuggestions="showSuggestions"
          :searchResults="searchResults" :hambergerContent="hambergerContent" @item-clicked="handleLinkClick"
          @brochure-item-clicked="pushBrochureDownloadDataLayer" :navElectives="navElectives" :navCourses="navCourses"
          :navPrograms="navPrograms" :navProgramInfo="navProgramInfo" :navCourseInfo="navCourseInfo"
          :changeElecBg="changeElecBg" :changeProgramBg="changeProgramBg" :courseBgMob="courseBgMob"
          :programBg="programBg" />
        <!-- Mobile Header -->

        <!--desktopHeader-->
        <div class="hidden md:flex p-4 justify-around items-center xl:justify-between">
          <div class="flex items-center">
            <div class="flex items-center">
              <router-link :to="{ name: 'home' }">
                <span class="w-[8rem] lg:w-[10rem] xl:w-full">
                  <img src="@/assets/home/jainLogoDesktop.svg" alt="jainLogo" fetchPriority="high"
                    class="w-[224px] h-[60px] object-contain" />
                </span>
              </router-link>
            </div>
            <div
              class="ml-[1rem] flex items-center gap-2 bg-[#F8C300] rounded-full py-1 px-4 xl:ml-[2rem] cursor-pointer"
              @click="toggleProgram('program')" ref="dropDownBtnProgram">
              <span class="text-sm lg:text-lg text-black font-bold">
                Programs
              </span>
              <span class="pt-[5px]">
                <img v-if="!program_select" src="@/assets/nav/down_blue.svg" class="w-[16px] h-[16px] object-contain"
                  alt="down arrow" decoding="async" />
                <img v-else src="@/assets/nav/up_blue.svg" class="w-[16px] h-[16px] object-contain" alt="up arrow"
                  decoding="async" />
              </span>
            </div>

            <div class="ml-[10px] flex items-center xl:ml-[2rem]">
              <span class="pr-[4px]">
                <img src="@/assets/home/graduation-cap.svg" alt="graduationCap" class="w-[22px] h-[13px]"
                  decoding="async" />
              </span>
              <div @click="handleApplyNowClick" class="cursor-pointer">
                <span class="text-white font-semibold text-base lg:text-lg">
                  Apply Now
                </span>
              </div>
              <!-- <div class="cursor-pointer">
                <a href="https://apply.onlinejain.com/" target="_blank"><span class="text-white font-semibold text-base lg:text-lg">
                  Apply Now
                </span></a>
              </div> -->
            </div>
          </div>

          <div class="flex items-center">
            <!-- <div
              class="mr-[1rem] flex items-center bg-[#F8C300] rounded-full py-1 px-4 xl:ml-[2rem] cursor-pointer"
              @click="enquire_now = true"
              ref="dropDownBtnProgram"
            >
              <span class="text-sm lg:text-lg text-black font-bold">
                Enquire Now
              </span>
            </div> -->

            <div class="mr-[1rem] flex items-center bg-[#F8C300] rounded-full py-1 px-4 xl:ml-[2rem] cursor-pointer">
              <div class="relative flex flex-col items-center">
              
                <button @click="showIframe = true">
                  <span
                    class="text-sm text-center lg:text-lg text-black font-bold"
                  >
                    Enquire Now
                  </span>
                </button>
              </div>
              <!-- <div class="relative flex flex-col items-center">
                <EnquireView :showForm="showForm" @close-form="closeForm" />

                <button @click="showForm = true">
                  <span class="text-sm text-center lg:text-lg text-black font-bold">
                    Enquire Now
                  </span>
                </button>
              </div> -->
            </div>
            <div class="flex items-center xl:mr-[1rem] cursor-pointer" @click="toggleWhyus('whyus')"
              ref="dropDownBtnWhyus">
              <span class="text-white text-base font-semibold lg:text-xl">
                Why Us
              </span>
              <span class="pl-[4px]">
                <img v-if="!navWhyus" src="@/assets/nav/down.svg" class="w-[16px] h-[16px] object-contain text-white"
                  alt="down arrow" />
                <img v-else src="@/assets/nav/up.svg" class="w-[16px] h-[16px] object-contain text-white"
                  alt="up arrow" />
              </span>
            </div>
            <div class="flex items-center ml-[10px] xl:mr-[1rem] cursor-pointer" @click="toggleNavSupport('support')"
              ref="dropDownBtnSupport">
              <span class="text-white text-base font-semibold lg:text-xl">
                Support
              </span>
              <span class="pl-[4px]">
                <img v-if="!navSupport" src="@/assets/nav/down.svg" class="w-[16px] h-[16px] object-contain text-white"
                  alt="down arrow" />
                <img v-else src="@/assets/nav/up.svg" class="w-[16px] h-[16px] object-contain text-white"
                  alt="up arrow" />
              </span>
            </div>

            <!-- search -->
            <div>
              <div class="relative">
                <div class="ml-[.8rem] xl:mr-[1rem] xl:mt-[2px] cursor-pointer" v-if="shouldShowIcon"
                  @click="toggleSearch">
                  <img src="@/assets/home/Icon-feather-search.svg" class="w-[19px] h-[21px]" alt="search"
                    title="Search" />
                </div>

                <!-- Search input -->
                <div ref="searchBox" v-if="showSearch"
                  class="search-box right-[10px] top-[60px] flex gap-2 items-center">
                  <input class="search-input w-[250px]" type="text" placeholder="Search..." v-model="searchTerm"
                    @input="fetchResults" @keyup.enter="goToSearchPage" />
                </div>
                <!-- Suggestions dropdown -->
                <ul v-if="showSuggestions"
                  class="search-suggestions absolute bg-white shadow-lg top-[110px] w-[290px] !right-[13px] z-50">
                  <li v-for="result in searchResults.slice(0, 6)" :key="result.id" @click="selectResult(result)">
                    <a :href="`/${result.program.short_slug}/${result.slug}`" v-if="result"
                      class="flex gap-3 items-center">
                      <p class="text-black text-[12px] text-start text-wrap font-semibold">
                        {{ result.program.short_name }} in
                        {{ result.name }}
                      </p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- search -->

            <router-link :to="{ name: 'NotificationView' }" title="notifications information">
              <div class="ml-[.8rem] xl:mr-[1rem] xl:mt-[2px]">
                <img src="@/assets/home/Icon-feather-bell.svg" alt="notification" class="w-[19px] h-[21px]" />
              </div>
            </router-link>
          </div>
        </div>

        <!---programContent-->
        <div class="bg-white absolute top-[100%] z-50 w-full left-0"
          v-show="this.selected_Val == 'program' && program_select">
          <ProgramDropdown :navElectives="navElectives" :navCourses="navCourses" :navPrograms="navPrograms"
            :navProgramInfo="navProgramInfo" :navCourseInfo="navCourseInfo" :changeElecBg="changeElecBg"
            :changeProgramBg="changeProgramBg" :navElectivesBg="navElectivesBg" :navProgramsBg="navProgramsBg"
            :courseBgMob="courseBgMob" />
        </div>
        <!---programContent-->
        <!--whyUs-->
        <div class="bg-white rounded-md absolute right-[25%] xl:right-[20%] 2xl:right-[25%] xxl:right-[31%] z-10"
          v-if="navWhyus && this.selected_Val == 'whyus'">
          <WhyUsDropdown @item-clicked="handleLinkClick" />
        </div>
        <!--whyUs-->
        <!--support-->
        <div class="bg-white rounded-md absolute right-[6%] lg:right-[8%] 2xl:right-[16%] xxl:right-[25%] z-10"
          v-if="navSupport && this.selected_Val == 'support'">
          <SupportDropdown @item-clicked="handleLinkClick" @brochure-item-clicked="pushBrochureDownloadDataLayer" />
        </div>
        <!--support-->
        <!--desktopHeader-->
      </div>
    </div>
    <EnquireView :showForm="showForm" @close-form="closeForm" />
    <BrochureView v-show="is_download_brochure_navAll == true" @close-button="is_download_brochure_navAll = false" />
    <!-- <ApplyView v-if="showApplyForm" @close="showApplyForm = false" /> -->
    <IframePopup v-if="showIframe" @close="showIframe = false" :widget_id="widget_id" />

  </div>
</template>

<script>
import axios from "axios";
import { useHead } from "@unhead/vue";
import MobileMenu from "@/components/General/MobileMenu.vue";
import ProgramDropdown from "@/components/General/ProgramDropdown.vue";
import WhyUsDropdown from "@/components/General/WhyUsDropdown.vue";
import SupportDropdown from "@/components/General/SupportDropdown.vue";
import EnquireView from "@/components/EnquirefromView.vue";
import BrochureView from "@/components/BrochureView.vue";
import ApplyView from "@/components/ApplyformView.vue";
import IframePopup from "@/components/IframeView.vue";
export default {
  props:["widget_id"],
  data() {
    return {
      is_download_brochure_navAll: false,
      toggleNavBurger: false,
      activeTab: null,
      activeInnerTab: null,
      hambergerContent: [
        {
          id: "tab1",
          title: "Programs",
        },
        {
          id: "tab2",
          title: "Why Us",
        },
        {
          id: "tab3",
          title: "Support",
        },
      ],

      navProgramData: "",
      navElectiveData: "",
      navWhyus: false,
      navSupport: false,
      selected_Val: "",
      navElectives: [],
      navPrograms: [],
      navCourses: [],
      navElectivesBg: "",
      navProgramsBg: "",
      programBg: "",
      courseBgMob: "",
      program_select: false,
      showSearch: false,
      searchTerm: "",
      searchResults: [],
      showSuggestions: false,
      showForm: false,
      showApplyForm: false,
      showIframe: false,
    };
  },
  components: {
    EnquireView,
    BrochureView,
    ApplyView,
    ProgramDropdown,
    WhyUsDropdown,
    SupportDropdown,
    MobileMenu,
    IframePopup,
  },

  async created() {
    this.navElectiveInfo();
    this.bindMetaTags();
  },

  // beforeUnmount() {
  //   document.removeEventListener("click", this.handleClickOutside);
  // },
  methods: {
    closeForm() {
      this.showForm = false;
      this.showApplyForm = false;
    },
    toggleProgram(val) {
      this.selected_Val = val;
      this.program_select = !this.program_select;
      this.navWhyus = false;
      this.navSupport = false;
    },
    toggleWhyus(val) {
      this.selected_Val = val;
      this.program_select = false;
      this.navSupport = false;
      this.navWhyus = !this.navWhyus;
    },
    toggleNavSupport(val) {
      this.selected_Val = val;
      this.program_select = false;
      this.navWhyus = false;
      this.navSupport = !this.navSupport;
    },
    // handleClickOutside(event) {
    //   if (this.selected_Val == "program") {
    //     if (
    //       this.toggleProgramNav &&
    //       !this.$refs.dropDownBtnProgram.contains(event.target) &&
    //       !this.$refs.dropdownProgramContent.contains(event.target)
    //     ) {
    //       this.toggleProgramNav = false;
    //     }
    //   } else if (this.selected_Val == "whyus") {
    //     if (
    //       this.navWhyus &&
    //       !this.$refs.dropDownBtnWhyus.contains(event.target) &&
    //       !this.$refs.dropdownWhyusContent.contains(event.target)
    //     ) {
    //       this.navWhyus = false;
    //     }
    //   } else {
    //     if (
    //       this.navSupport &&
    //       !this.$refs.dropDownBtnSupport.contains(event.target) &&
    //       !this.$refs.dropdownSupportContent.contains(event.target)
    //     ) {
    //       this.navSupport = false;
    //     }
    //   }
    // },
    navElectiveInfo() {
      axios
        .get(`${process.env.VUE_APP_API}/course/category-list/`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.navElectives = resp.data.data;
            this.navElectiveData = this.navElectives[0].id;
            this.navElectivesBg = this.navElectives[0].name;
            this.navProgramInfo(this.navElectiveData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    navProgramInfo(id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/course/program-list/?category__id=${id}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.navPrograms = resp.data.data;
            this.navCourseInfo(this.navPrograms[0].id);
            this.navProgramsBg = this.navPrograms[0].short_name;
            this.navProgramData = this.navPrograms[0].id;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async navCourseInfo(id) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/menu/course/elective-list/?program__id=${id}`
        );

        if (response.data.status === 200) {
          this.navCourses = response.data.data;

          this.navCourses.forEach((course) => {
            course.modifiedSlug = this.modifiedSlug(course.slug);
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    changeElecBg(courseName) {
      this.navElectivesBg = courseName;
      this.programBg = courseName;
    },
    changeProgramBg(data) {
      this.navProgramsBg = data;
      this.courseBgMob = data;
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(value);
    },
    bindMetaTags() {
      var metaTagDic = {};
      metaTagDic["meta"] = [];
      metaTagDic["link"] = [];
      metaTagDic["title"] = "";
      metaTagDic["script"] = [];
      axios
        .get(
          `${process.env.VUE_APP_API}/seo-list/?url=https://onlinejain.com${this.$route.path}`
        )
        .then((resp) => {
          // console.log(resp, "HEllO");
          if (
            resp.data.status == 200 &&
            resp.data.data &&
            resp.data.data.length > 0
          ) {
            var result = resp.data.data[0];

            metaTagDic["title"] = result.title;

            metaTagDic["meta"] = [
              { name: "description", content: result.description },
              { property: "og:title", content: result.og_title },
              { property: "og:description", content: result.og_description },
              { property: "og:url", content: result.og_site_url },
              { property: "og:type", content: "website" },
              { property: "og:image", content: result.og_img },
              { property: "og:image:width", content: "851" },
              { property: "og:image:height", content: "315" },
              {
                name: "twitter:card",
                content: "summary_large_image",
              },
              { name: "twitter:domain", content: "onlinejain.com" },
              { name: "twitter:url", content: result.og_site_url },
              { name: "twitter:image", content: result.twitter_img },
              { name: "twitter:image:alt", content: result.og_title },
              { name: "twitter:title", content: result.og_title },
              { name: "twitter:description", content: result.og_description },
            ];

            metaTagDic["link"] = [
              {
                rel: "canonical",
                href: result.url,
              },
            ];
            // Check if schema code is valid and give the result accordingly
            if (result.schema_code) {
              try {
                var rs = JSON.parse(result.schema_code);
                if (Array.isArray(rs) && rs.length > 0) {
                  metaTagDic["script"] = rs.map((item) => {
                    return {
                      type: "application/ld+json",
                      textContent: JSON.stringify(item),
                    };
                  });
                }
              } catch (error) {
                console.error("Invalid JSON data:", error);
              }
            }
            useHead({
              title: metaTagDic["title"],
              meta: metaTagDic["meta"],
              link: metaTagDic["link"],
              script: metaTagDic["script"],
            });
          }
        });
    },
    toggleSearch() {
      this.showSearch = !this.showSearch;
      if (this.showSearch) {
        this.$nextTick(() => {
          this.$refs.searchBox.querySelector("input").focus();
        });
      }
    },
    fetchResults() {
      if (this.searchTerm.length > 0) {
        axios
          .get(
            `${process.env.VUE_APP_API
            }/landingpage-search/?search=${encodeURIComponent(this.searchTerm)}`
          )
          .then((response) => {
            console.log("API Response Data:", response.data);
            this.searchResults = response.data.electives;
            this.showSuggestions = true;
          })
          .catch((error) => {
            console.error("Error fetching search results:", error);
          });
      } else {
        this.searchResults = [];
        this.showSuggestions = false;
      }
    },
    selectSuggestion(suggestion) {
      console.log("Selected suggestion:", suggestion);
      this.searchTerm = suggestion.title;
      this.showSuggestions = false;
    },
    async goToSearchPage() {
      if (this.searchTerm && this.searchTerm.trim() !== "") {
        try {
          const response = await axios.get(
            `${process.env.VUE_APP_API
            }/landingpage-search/?search=${encodeURIComponent(this.searchTerm)}`
          );

          const programs = response.data.programs || [];
          const electives = response.data.electives || [];
          const blogs = response.data.blogs || [];

          // Determine the most relevant tab
          let activeTab = "Programs";
          if (electives.length > 0 && programs.length === 0) {
            activeTab = "Electives";
          } else if (
            blogs.length > 0 &&
            electives.length === 0 &&
            programs.length === 0
          ) {
            activeTab = "Blogs";
          } else if (electives.length > 0 && programs.length > 0) {
            // If both electives and programs are present, determine based on search term relevance
            const electiveMatch = electives.some((elective) =>
              this.searchTerm
                .toLowerCase()
                .includes(elective.name.toLowerCase())
            );
            const programMatch = programs.some((program) =>
              this.searchTerm.toLowerCase().includes(program.name.toLowerCase())
            );
            activeTab =
              electiveMatch && !programMatch ? "Electives" : "Programs";
          }

          // Store the active tab data in localStorage
          localStorage.setItem("searchTerm", this.searchTerm);
          localStorage.setItem("activeTab", activeTab);

          // Perform the navigation to search page
          window.isProgrammaticNavigation = true;
          this.$router.push(`/search?tab=${activeTab}`);
        } catch (error) {
          console.error("Error determining search results:", error);
          alert("Error processing the search. Please try again.");
        }
      } else {
        alert("Please enter a search term");
      }
    },
    handleApplyNowClick() {
      dataLayer.push({
        "event": "Apply Online Initiated",
        "Attribute": {
          "CTA": "Apply Now",
          "Section Name": "Header",
        },
      });
      if (this.widget_id!=null && this.widget_id!='' ) {
        window.open(`https://apply.onlinejain.com/?id=${this.widget_id}`, "_blank");
      } else {
        window.open("https://apply.onlinejain.com/", "_blank");
     
      }

      // this.showApplyForm = true;
    },
    handleButtonClick() {
      dataLayer.push({
        "event": "Enquire Now Clicked",
        "Attribute": {
          // No specific attributes are available to push
        },
      });
      this.showForm = true;
    },
    pushBrochureDownloadDataLayer(data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        "event": "Brochure Download Clicked",
        "Attribute": {
          "Elective Title": data.electiveTitle,
          "Elective ID": "",
          "Program": "",
          "Program ID": "",
          "Domain": "",
          "Domain ID": "",
          "Elective Details": "",
          "Duration": "",
          "Batch Start Date": "",
          "CTA Section": data.ctaSection,
        },
      });
    },
    handleLinkClick(title, sectionName, Url) {
      dataLayer.push({
        "event": "Menu Clicked",
        "Attribute": {
          "Title": title,
          "ID": "",
          "Menu Page URL": Url,
          "Section Name": sectionName,
        },
      });
    },
  },
  computed: {
    modifiedSlug() {
      return (slug) => {
        const specialSlugs = ["hr-finance", "hr-marketing"];

        let words = slug.split("-");

        let modifiedWords = words.map((word, index) => {
          if (specialSlugs.includes(slug) && index === 0) {
            return word.substring(0, 2).toUpperCase() + word.substring(2);
          } else {
            return word.charAt(0).toUpperCase() + word.slice(1);
          }
        });

        let modifiedSlug = modifiedWords.join(" ");

        return modifiedSlug;
      };
    },
    electives() {
      return ["BBA", "MBA", "MCA", "Other Electives"];
    },
    shouldShowIcon() {
      return this.$route.path !== "/search";
    },
  },
};
</script>

<style scoped>
.search-box {
  position: absolute;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 50px;
  z-index: 1000;
}

.search-results {
  list-style-type: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid #ccc;
}

.search-results li {
  padding: 8px 12px;
  cursor: pointer;
}

.search-results li:hover {
  background-color: #f0f0f0;
}

.search-input {
  border: none;
  outline: none;
}

.search-suggestions {
  list-style-type: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  color: black;
}

.search-suggestions li {
  padding: 10px;
  cursor: pointer;
}

.search-suggestions li:hover {
  background-color: #f0f0f0;
}
</style>
